import { React, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

import { richTextToHtml } from '../util/text';
import { bannerSkeleton,
        pageSkeleton,
        vacaturesReclameSkeleton,
        aanmeldenVacaturesSkeleton
      } from '../util/skeletons';

import "../styles/pages/VerkeersregelaarsPage.scss";

import VacaturesLink from '../components/molecules/VacaturesLink';
import KeepUpdated from "../components/molecules/KeepUpdated";
import Button from "../components/atoms/Button";
import DocumentHead from "../components/atoms/DocumentHead";
import { getContent } from '../services/ContentService';

const VerkeersregelaarsPage = () => {

  const navigate = useNavigate();
  const [verkeerBanner, setVerkeerBanner] = useState(bannerSkeleton);
  const [pageContent, setPageContent] = useState(pageSkeleton)
  const [vacaturesReclame, setVacaturesReclame] = useState(vacaturesReclameSkeleton);
  const [aanmeldenVacatures, setAanmeldenVacatures] = useState(aanmeldenVacaturesSkeleton);

  useEffect(() => {
    getContent({
      content_type: 'verkeersregelaarsPagina',
    })
      .then((response) => {
        setPageContent(response.items[0].fields)
        setVerkeerBanner(response.items[0].fields.banner.fields)
        setVacaturesReclame(response.items[0].fields.vacaturesReclame.fields)
        setAanmeldenVacatures(response.items[0].fields.aanmeldenVacatures.fields)
      })
      .catch(console.error);
  }, [])

  return (
    <div className='verkeersregelaars'>
      <DocumentHead
        title="Verkeersregelaars | Ageras"
        metaDescription="Ageras Verkeersregelaars is de flexibele schil binnen de uitzendbranche. Van magazijnmedewerkers tot dakdekkers, geen enkele uitdaging is voor ons te veel."
      />
      <div className='verkeersregelaars-banner'>
        <div className='verkeersregelaars-banner-image'>
          <img src={verkeerBanner.plaatje.fields.file.url} alt={verkeerBanner.plaatje.fields.description} />
        </div>

        <div className='verkeersregelaars-banner-content'>
          <div className='verkeersregelaars-banner-content-text'>
            <h1 className='verkeersregelaars-banner-content-text-title'>{verkeerBanner.titel}</h1>
            {richTextToHtml(verkeerBanner.tekst.content, "verkeersregelaars-banner-content-text-text")} 
          </div>

          <div className='verkeersregelaars-banner-content-footer'>
            <div className='verkeersregelaars-banner-content-footer-button'>
              <Button
                color={"lightGrey"}
                onClick={() => {
                  navigate(`/${verkeerBanner.secundaireLink[0]}`);
                }}
                title={verkeerBanner.secundaireLink[1]}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='verkeersregelaars-line'></div>

      <div className='verkeersregelaars-inhoud'>
        <div className='verkeersregelaars-inhoud-image'>
          <img src={pageContent.inhoudPlaatje.fields.file.url} alt={pageContent.inhoudPlaatje.fields.description} />
        </div>

        <div className='verkeersregelaars-inhoud-content'>
          <h1 className='verkeersregelaars-inhoud-content-title'>{pageContent.inhoudTitel}</h1>
          {richTextToHtml(pageContent.inhoudTekst.content, "verkeersregelaars-inhoud-content-text")}
        </div>
      </div>

    {
        pageContent.bedrijvenLogos && (
            <>
                <div className='verkeersregelaars-line'></div>

                <div className='verkeersregelaars-bedrijven'>
                    <h1 className='verkeersregelaars-bedrijven-title'>{pageContent.bedrijvenTitel}</h1>
                    <div className='verkeersregelaars-bedrijven-overzicht'>
                    {pageContent.bedrijvenLogos.map((logo, i) => (
                      (logo.fields && logo.fields.file) && (
                        <div className='verkeersregelaars-bedrijven-image' key={i}>
                          <img src={logo.fields.file.url} alt={logo.fields.description} />
                        </div>
                      )
                    ))}
                    </div>
                </div>
            </>
        )
    }

      <VacaturesLink
        content={vacaturesReclame}
      />

      <KeepUpdated
        content={aanmeldenVacatures}
      />

    </div>
  )
}

export default VerkeersregelaarsPage;